import axios, { AxiosResponse } from 'axios';
import { ISubjObcanstvi, ISubjPrilozenesoubory } from 'types/amlz';

import { ICertKontrolaResp } from 'services/spravaUzivatelu/uzivatele';

import { EStavPodpisu } from 'enums/dokumentyEnums';
import { EUpozorneni } from 'enums/statniSprava/upozorneni';

import { EStavZadostAmlz } from './historickeZadosti';

export enum EPristupStav {
    ZADNA = 'ZADNA',
    ROZP = 'ROZP',
    CEKA = 'CEKA',
    KDOPL = 'KDOPL'
}
export enum EZadostPravoZastupuje {
    FODVR = 'FODVR', // fyzická osoba dle výpisu z veřejného rejstříku
    FOZPM = 'FOZPM', // fyzická osoba na základě plné moci
    POZJO = 'POZJO', // fyzická osoba na základě jiného oprávnění
    PODVR = 'PODVR', // právnická osoba dle výpisu z veřejného rejstříku
    POZPM = 'POZPM' // právnická osoba na základě plné moci
}
export enum EZadostPravoIdentifikace {
    EL = 'EL', // ELEKTRONICKY - osoba prokázala svoji osobu kvalifikovaným podpisem, tak smlouvu podepíše též podpisem
    SC = 'SC', // SCANDOKUMENTU - osoba přiložila scan obačenky, tak nyní přiloží scan podpisu - dle části C2
    BI = 'BI' // osoba se přihlásila pomoci BI AMLZ
}
export enum EZadostPravoPristup {
    PXKLIC = 'PXKLIC', // uživatelské jmeno heslo a PX klíč
    CERT = 'CERT', // komereční certikát
    UZIV = 'UZIV', // uživatelské jmeno heslo
    BI = 'BI' // bankovní identita
}
export interface IZadostPravoResp {
    pristupamlz?: {
        stav?: EPristupStav;
        datumzmeny?: string;
        idosoby?: number;
        id: number;
    };
    pristupc2?: {
        stav?: EPristupStav;
        datumzmeny?: string;
        idosoby?: number;
        idprofilu?: number;
        id: number;
        isBankIDredirect?: boolean;
        stat?: string;
    };
    osobaData?: {
        autprvek?: string;
        email?: string;
        jmeno?: string;
        prijmeni?: string;
        telefon?: string;
    };
}

export interface ISubjPristup {
    id?: number;
    username?: string;
    certdn: string;
    certiss: string;
    certsn?: string;
    bisub?: string;
    biname?: string;
    typprihlaseni: EZadostPravoPristup;
}
export interface ISubjPravo {
    bisub?: boolean; // prihlasil sa cez banksign
    jmeno?: string;
    prijmeni?: string;
    email?: string;
    telefon?: string;
    stat?: string;
    misto?: string;
    idmb?: string;
    datumnar?: string;
    adma?: string;
    mema?: string;
    pscm?: string;
    kost?: string;
    doplneno?: boolean;
    obcanstvi?: ISubjObcanstvi[];
    bsi?: string;
    datumztotozneni?: string;
    zastupuje?: EZadostPravoZastupuje;
    identifikaceosoby?: EZadostPravoIdentifikace;
    prilozenesoubory?: ISubjPrilozenesoubory[];
    pristup?: {
        puvodni?: ISubjPristup;
        novy?: ISubjPristup;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typprihlaseni?: any; // TODO: MHO - doplnit typ
    };
    pristupdepozitar?: 'ANO' | 'NE' | 'POZDEJI';
    zmenapristupu?: 'NOVYJEDENUCET' | 'NOVYVSECHNYUCTY' | 'UZIVJEDENUCET' | 'UZIVVSECHNYUCTY';
    agenda?: {
        typ?: string;
        platnostdo?: string;
    }[];
    ucet?: {
        predcisli: string;
        cislouctu: string;
        banka: string;
        iban?: string;
        varsym?: string;
        castka?: string;
        mena?: string;
        prilozenysoubor?: {
            oblast: 'DOKLAD';
            tempnazev: string;
            orignazev: string;
        };
    };
    stav?: EStavZadostAmlz;
    vyjadreni?: string;
    pep?: boolean;
    autprvek?: string;
}

export const zadostPravoCheck = () => {
    return axios({
        method: 'GET',
        url: '/AMLpristup'
    }).then((resp: AxiosResponse<IZadostPravoResp>) => resp.data);
};

export const zadostPravoZalozit = (typ: 'PRISTUPC2' | 'PRISTUPAMLZ') => {
    return axios({
        method: 'POST',
        url: '/AMLpristup/zalozit',
        data: {
            typ: typ
        }
    }).then((resp: AxiosResponse<IZadostPravoResp>) => resp.data);
};

export const zadostPravoGET = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/AMLpristup/${id}`
    }).then((resp: AxiosResponse<ISubjPravo>) => resp.data);
};

export const zadostPravoPUT = (id: number | string, data: ISubjPravo) => {
    return axios({
        method: 'PUT',
        url: `/AMLpristup/${id}`,
        data: data
    }).then((resp: AxiosResponse<{ stav: string }>) => resp.data);
};
export const zadostPravoPOST = (id: number | string, data: ISubjPravo) => {
    return axios({
        method: 'POST',
        url: `/AMLpristup/${id}`,
        data: data
    });
};

export const zadostPravoZrusit = (id: number | string) => {
    return axios({
        method: 'POST',
        url: `/AMLpristup/${id}/zrusit`
    });
};
export const zadostPravoVyjadreni = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/AMLpristup/${id}/vyjadreni`
    }).then((resp: AxiosResponse<{ vyjadreni: string }>) => resp.data);
};

export const pdfBiRerouteApi = (id: number | string, jazyk: 'cz' | 'en') => {
    return axios({
        method: 'POST',
        // url: `/${isSmsLogin ? 'AMLodkaz' : 'AMLpristup'}/${id}/pdfbisign`,
        url: `/AMLpristup/${id}/pdfbisign`,
        data: {
            jazyk: jazyk
        }
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};

export const pdfBiSmsRerouteApi = (id: number | string, osobaId: number | string, jazyk: 'cz' | 'en') => {
    return axios({
        method: 'POST',
        url: `/AMLodkaz/${id}/osobac2/${osobaId}/pdfbisign`,
        data: {
            jazyk: jazyk
        }
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};

export const biAmlzRerouteApi = (id: number | string, jazyk: 'cz' | 'en') => {
    return axios({
        method: 'POST',
        // url: `/${isSmsLogin ? 'AMLodkaz' : 'AMLpristup'}/${id}/biamlz`,
        url: `/AMLpristup/${id}/biamlz`,
        data: {
            jazyk: jazyk
        }
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};

export const biAmlzSmsRerouteApi = (id: number | string, osobaId: number | string, jazyk: 'cz' | 'en') => {
    return axios({
        method: 'POST',
        url: `/AMLodkaz/${id}/osobac2/${osobaId}/biamlz`,
        data: {
            jazyk: jazyk
        }
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const saveFile = (resp: AxiosResponse<any>, id: string | number) => {
    // způsob, jak stažený dokument otevřít v browseru
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const nav = window.navigator as any;
    // IE
    if (nav?.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(resp.data, `Formulař k podpisu_${id}.pdf`);
    } else {
        const odp = resp.data;

        const uriContent = URL.createObjectURL(
            new Blob([odp], {
                type: 'application/octetstream'
            })
        );
        const link = document.createElement('a');
        link.style.display = 'none';
        link.download = `Formulař k podpisu_${id}.pdf`;
        link.href = uriContent;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

export const pdfPodpisApi = (id: number | string) => {
    return axios({
        method: 'POST',
        // url: `/${isSmsLogin ? 'AMLodkaz' : 'AMLpristup'}/${id}/pdfdownload`,
        url: `/AMLpristup/${id}/pdfdownload`,
        responseType: 'blob' // important
    }).then(resp => {
        if (resp.status === 200) {
            saveFile(resp, id);
            // // způsob, jak stažený dokument otevřít v browseru
            // // eslint-disable-next-line @typescript-eslint/no-explicit-any
            // const nav = window.navigator as any;
            // // IE
            // if (nav?.msSaveOrOpenBlob) {
            //     nav.msSaveOrOpenBlob(resp.data, `Formulař k podpisu_${id}.pdf`);
            // } else {
            //     const odp = resp.data;

            //     const uriContent = URL.createObjectURL(
            //         new Blob([odp], {
            //             type: 'application/octetstream'
            //         })
            //     );
            //     const link = document.createElement('a');
            //     link.style.display = 'none';
            //     link.download = `Formulař k podpisu_${id}.pdf`;
            //     link.href = uriContent;
            //     link.target = '_blank';
            //     document.body.appendChild(link);
            //     link.click();
            //     document.body.removeChild(link);
            // }
        }
    });
};

export const pdfPodpisSmsApi = (id: number | string, osobaId: number | string) => {
    return axios({
        method: 'POST',
        url: `/AMLodkaz/${id}/osobac2/${osobaId}/pdfdownload`,
        responseType: 'blob' // important
    }).then(resp => {
        if (resp.status === 200) {
            saveFile(resp, id);
        }
    });
};

/* login sluzby */

export interface IZadostPravoLoginResp {
    platnost: boolean;
    idzaznamu: number;
    idosoby: number;
    stav: EStavZadostAmlz;
    stat?: string;
}
export interface IZadostPravoSMSLoginResp {
    prihlasen: boolean;
    token: string;
    idzaznamu: number;
    idosoby: number;
    stav: EStavZadostAmlz;
    stat?: string;
}

export const zadostPravoLoginSMS = (hash: string) => {
    return axios({
        method: 'POST',
        url: '/AMLodkaz/sms',
        data: {
            hash: hash
        }
    });
};

export const zadostPravoLoginSMSlogin = (hash: string, sms: string) => {
    return axios({
        method: 'POST',
        url: '/AMLodkaz/prihlasit',
        data: {
            hash: hash,
            sms: sms
        }
    }).then((resp: AxiosResponse<IZadostPravoSMSLoginResp>) => resp.data);
};

export const zadostPravoLoginGet = (hash: string) => {
    return axios({
        method: 'GET',
        url: '/AMLodkaz/',
        params: {
            hash: hash
        }
    }).then((resp: AxiosResponse<IZadostPravoLoginResp>) => resp.data);
};

export const amlzC2smsDetailGet = (id: number, osobaId: number) => {
    return axios({
        method: 'GET',
        url: `/AMLodkaz/${id}/osobac2/${osobaId}`
    }).then((resp: AxiosResponse<ISubjPravo>) => resp.data);
};

export const certKontrolaSmsApi = (tempnazev: string, idzad: number, id: number) => {
    return axios({
        method: 'GET',
        url: `/AMLodkaz/${idzad}/osobac2/${id}/Certifikat/Kontrola`,
        params: {
            tempnazev: tempnazev
        }
    }).then((resp: AxiosResponse<ICertKontrolaResp>) => resp.data);
};

export const amlzC2smsDetailsend = (
    id: number | string,
    osobaId: number | string,
    data: ISubjPravo,
    type: 'PUT' | 'POST'
) => {
    return axios({
        method: type,
        url: `/AMLodkaz/${id}/osobac2/${osobaId}`,
        data: data
    }).then(resp => resp.data);
};

export interface IRedirectLoginResp {
    token: string;
    typ?: string;
    podtyp?: string;
    zadostoid: number;
    osobaoid: number;
    ucetoid: number;
    jazyk: 'cz' | 'en';
    // mepozadavky
    sluzba?: string;
    requestoid?: number;
    datum?: string;
    upozor?: {
        typ: EUpozorneni;
    }[];
    stav: EStavPodpisu; // stav podpisu dokument
}

export const bankidRedirectLogin = (hash: string) => {
    return axios({
        method: 'POST',
        url: '/bankid/pristup',
        data: {
            hash: hash
        }
    }).then((resp: AxiosResponse<IRedirectLoginResp>) => resp.data);
};

/* osoby sluzby */

export interface IOsobyGetInput {
    order: string;
    limit: number;
    offset: number;
}

export interface Iosoba {
    id: number;
    jmeno?: string;
    prijmeni?: string;
    telefon?: string;
    email?: string;
    autprvek?: EZadostPravoPristup;
    stav?: EStavZadostAmlz;
    idzadosti?: number;
    idosoby?: number;
    datum?: string;
    typzadosti?: string;
    duplicita?: number;
}

export interface IOsobyGetResp {
    count: number;
    order: string;
    limit: number;
    offset: number;
    osoby: Iosoba[];
}

export const osobyC2Get = (data: IOsobyGetInput) => {
    return axios({
        method: 'GET',
        url: '/AMLosobyc2',
        params: {
            ...data
            // order: data.order ? data.order + ':id:desc' : 'id:desc'
        }
    }).then((resp: AxiosResponse<IOsobyGetResp>) => resp.data);
};

export const osobyC2Aktualizovat = (id: string | number) => {
    return axios({
        method: 'POST',
        url: `/AMLosobyc2/${id}/aktualizovat`
    }).then(
        (
            resp: AxiosResponse<{
                idzadosti: number;
                idosoby: number;
                stav: 'ZALOZENO' | 'NELZEC2' | 'NELZEAML';
                uzivatel: string;
            }>
        ) => resp.data
    );
};
export const osobyC2Nova = () => {
    return axios({
        method: 'POST',
        url: '/AMLosobyc2/pridat'
    }).then(
        (
            resp: AxiosResponse<{
                idzadosti: number;
                idosoby: number;
                stav: 'ZALOZENO' | 'NELZEC2' | 'NELZEAML';
                uzivatel: string;
            }>
        ) => resp.data
    );
};

export const osobyC2Zrusit = (id: string | number) => {
    return axios({
        method: 'POST',
        url: `/AMLosobyc2/${id}/zrusit`
    });
};

export const osobyC2Odebrat = (idUziv: string | number, idZadost: string | number) => {
    return axios({
        method: 'POST',
        url: `/AML/${idZadost}/osobyc2/${idUziv}/odebrat`
    });
};
